export const WISHLIST_DEFAULT_STATE = 'WISHLIST_DEFAULT_STATE';
export const WISHLIST_LOADING_STATE = 'WISHLIST_LOADING_STATE';
export const WISHLIST_FINISHED_STATE = 'WISHLIST_FINISHED_STATE';
//# sourceMappingURL=constants.js.map